<div class="housekeeping-report">
  <p-toast [style]="{marginTop: '80px'}"></p-toast>
  <p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>
  @if (formLoading) {
    <div class="kbm-search-loading">
      <p-progressSpinner></p-progressSpinner>
    </div>
  }
  <p-table #pt [value]="housekeepingReports" [lazy]="true" (onLazyLoad)="loadLazy($event)"
    dataKey="housekeepingReportId" selectionMode="single" [(selection)]="housekeepingReport" [loading]="loading"
    [paginator]="showPagination" [rows]="1000" [rowsPerPageOptions]="[1000]" showCurrentPageReport="true"
    currentPageReportTemplate="{totalRecords} results. Page {currentPage} of {totalPages}" [totalRecords]="recordTotal"
    sortMode="multiple" [multiSortMeta]="multiSortMeta" styleClass="p-datatable-striped" [ngStyle]="{'width': 'auto'}"
    [resizableColumns]="true" [autoLayout]="true" [responsive]="true">
    <ng-template pTemplate="caption">
      <div [formGroup]="form1" class="forms d-block">
        <div class="row justify-content-center m-0">
          <div class="col-lg-12 d-flex justify-content-center">
            <app-search-template searchLabel="Search" [showSearchButton]="true" [reset]="true" [showLocations]="true"
              [showDevelopments]="true" [showShortTermRentals]="true" [showRateBuckets]="false" [showBedrooms]="false"
              [showSeasons]="false" [startDate]="defaultStartDate" [endDate]="defaultEndDate" [showStartDate]="true"
              [showEndDate]="true" [showSaleDateStart]="false" [showSaleDateEnd]="false" [showSaleYear]="false"
              [displayRecordsOnPageLoad]="false" [showBlankStartAndEndDate]="true" [showReferralSources]="false"
              [showReservationStatus]="true" (doSearchCB)="onSearchSubmit($event)">
            </app-search-template>
          </div>
        </div>
        <div class="row justify-content-between m-0 mt-2 align-items-center">
          <div class="col-lg-6">
          </div>
          <div class="col-lg-6 d-flex justify-content-end">
            <button #exportButton type="button" pButton pRipple label="Export PDF" icon="pi pi-file-pdf"
              class="p-button-primary p-button-sm" (click)="exportPDF()"
              [disabled]="formLoading || !housekeepingReports || housekeepingReports.length === 0">
            </button>
          </div>
        </div>
      </div>
    </ng-template>

    <ng-template pTemplate="body" let-housekeepingReport let-i="rowIndex">

      <div [id]="'pdf-content-' + i" style="padding: 10px; background: white;">
        <p-table [value]="[housekeepingReport]" styleClass="p-datatable-sm" [style]="{'font-size':'12px'}"
          [tableStyle]="{'margin': '0', 'padding': '0', 'border-collapse': 'collapse'}">
          <ng-template pTemplate="body" let-reservation>
            <tr style="margin:0px;padding:0px;font-size:12px;font-weight:normal;outline:none;border:none">
              <td colspan="3" style="margin:0px;padding:0px;font-size:12px;font-weight:normal;outline:none;border:none"
                bgcolor="#DCD4D7" align="left"><span
                style="margin:0px;padding:0px;font-size:14.4px;font-weight:normal;outline:none;vertical-align:baseline;text-decoration:none"><b
                style="margin:0px;padding:0px;font-size:12px;font-weight:bold;outline:none">
              {{housekeepingReport?.analyzedDate | date:'EEEE MMMM dd, yyyy'}} </b></span>
            </td>
          </tr>
          <tr style="margin:0px;padding:0px;font-size:12px;font-weight:normal;outline:none;border:none">
            <td colspan="3">
              <br style="margin:0px;padding:0px">
            </td>
          </tr>
          <tr style="margin:0px;padding:0px;font-size:12px;font-weight:normal;outline:none;border:none">
            <td colspan="3">
              <b style="margin:0px;padding:0px;font-size:12px;font-weight:bold;outline:none">Resort Summary</b>
            </td>
          </tr>
          <tr style="margin:0px;padding:0px;font-size:12px;font-weight:normal;outline:none;border:none">
            <td colspan="3">
              <p-table [value]="housekeepingReport?.reportSummaries" [style]="{'font-size':'12px'}"
                [tableStyle]="{'margin': '0', 'padding': '0', 'border-collapse': 'collapse','table-layout':'fixed'}"
                class="p-datatable-sm p-datatable-gridlines">

                <ng-template pTemplate="header">
                  <tr>
                    <th style="text-align: right;"></th>
                    <th style="text-align: center;">OUTs</th>
                    <th style="text-align: center;">INs</th>
                  </tr>
                </ng-template>

                <ng-template pTemplate="body" let-reportSummary>
                  <tr>
                    <td style="text-align: right;">{{ reportSummary?.developmentCode }}</td>
                    <td style="text-align: center;">{{ reportSummary?.checkOutTotal }}</td>
                    <td style="text-align: center;">{{ reportSummary?.checkInTotal }}</td>
                  </tr>
                </ng-template>

                <ng-template pTemplate="footer">
                  <tr>
                    <td style="text-align: right; font-weight: bold;">Total</td>
                    <td style="text-align: center;">{{ housekeepingReport?.totalCheckOut }}</td>
                    <td style="text-align: center;">{{ housekeepingReport?.totalCheckIn }}</td>
                  </tr>
                </ng-template>

              </p-table>
            </td>
          </tr>
          <tr style="margin:0px;padding:0px;font-size:12px;font-weight:normal;outline:none;border:none">
            <td colspan="3">
              <br style="margin:0px;padding:0px">
            </td>
          </tr>
          <tr>
            <td colspan="3">
              <b style="margin:0px;padding:0px;font-size:12px;font-weight:bold;outline:none">Interim Cleanings Today:
                {{housekeepingReport?.interimCleaningSummaries?.length > 0 ?
                housekeepingReport.interimCleaningSummaries.length: 'NONE'}}
              </b><br style="margin:0px;padding:0px"><br style="margin:0px;padding:0px">
            </td>
          </tr>
          @if (housekeepingReport?.interimCleaningSummaries?.length > 0) {
            <tr>
              <td colspan="3">
                <app-interim-cleaning [housekeepingReport]="housekeepingReport"></app-interim-cleaning>
              </td>
            </tr>
          }
          <tr>
            <td colspan="3">
              <b style="margin:0px;padding:0px;font-size:12px;font-weight:bold;outline:none">Liner Cleanings Today:
                {{housekeepingReport?.linenServiceSummaries?.length > 0 ? housekeepingReport.linenServiceSummaries.length:
                'NONE'}}
              </b><br style="margin:0px;padding:0px"><br style="margin:0px;padding:0px">
            </td>
          </tr>
          @if (housekeepingReport?.linenServiceSummaries?.length > 0) {
            <tr>
              <td colspan="3">
                <app-interim-cleaning [housekeepingReport]="housekeepingReport"></app-interim-cleaning>
              </td>
            </tr>
          }
          <tr style="margin:0px;padding:0px;font-size:12px;font-weight:normal;outline:none;border:none">
            <td colspan="3">
              <b style="margin:0px;padding:0px;font-size:12px;font-weight:bold;outline:none">Roll-Away
              Bed Locations:</b>
              <app-rollaway-bad [housekeepingReport]="housekeepingReport"></app-rollaway-bad>
              <wbr>
              </td>
            </tr>
            <tr style="margin:0px;padding:0px;font-size:12px;font-weight:normal;outline:none;border:none">
            <td colspan="3">
              <b style="margin:0px;padding:0px;font-size:12px;font-weight:bold;outline:none">Futon
              Bed Locations:</b>
              <app-futon-bad [housekeepingReport]="housekeepingReport"></app-futon-bad>
              <wbr>
              </td>
            </tr>
            <tr style="margin:0px;padding:0px;font-size:12px;font-weight:normal;outline:none;border:none">
              <td style="margin:0px;padding:0px;font-size:12px;font-weight:normal;outline:none;border:none"><br
              style="margin:0px;padding:0px"></td>
            </tr>
            <tr style="margin:0px;padding:0px;font-size:12px;font-weight:normal;outline:none;border:none">
              <td colspan="3">
                <b style="margin:0px;padding:0px;font-size:12px;font-weight:bold;outline:none">Open Units
                Today:</b>
                <app-open-unit [housekeepingReport]="housekeepingReport"></app-open-unit>
              </td>
            </tr>
            <tr style="margin:0px;padding:0px;font-size:12px;font-weight:normal;outline:none;border:none">
              <td colspan="3">
                <br>
                </td>
              </tr>
              <tr style="margin:0px;padding:0px;font-size:12px;font-weight:normal;outline:none;border:none">
                <td style="width: 10%; vertical-align: top; padding: 0;">
                  <br style="margin:0px;padding:0px">
                </td>
                <td style="text-align: center; width: 45%; vertical-align: top; padding: 0;"><b>OUT</b></td>
                <td style="text-align: center; width: 45%; vertical-align: top; padding: 0;"><b>IN</b></td>
              </tr>
              @for (changeoverProperty of housekeepingReport.changeoverProperties; track changeoverProperty) {
                <tr style="margin:0px;padding:0px;font-size:12px;font-weight:normal;outline:none;border:none"
                  >
                  <td style="width: 10%;">
                    <span
                      style="margin:0px;padding:0px;font-size:14.4px;font-weight:normal;outline:none;vertical-align:baseline;text-decoration:none">
                      <b
                      style="margin:0px;padding:0px;font-size:12px;font-weight:bold;outline:none">{{changeoverProperty?.propertyCode}}</b>
                    </span>
                    <br style="margin:0px;padding:0px">
                    <span
                    style="margin:0px;padding:0px;font-size:9.6px;font-weight:normal;outline:none;vertical-align:baseline;text-decoration:none">{{changeoverProperty?.developmentCode}}</span>
                  </td>
                  <td style="width: 45%; vertical-align: top;">
                    @if (changeoverProperty?.reservationDepartureApi) {
                      <app-report-reservation
                        [reservation]="changeoverProperty?.reservationDepartureApi"
                      [isPrintMode]="isPrintMode"></app-report-reservation>
                    }
                  </td>
                  <td style="width: 45%; vertical-align: top;">
                    @if (changeoverProperty?.reservationArrivalApi) {
                      <app-report-reservation
                        [reservation]="changeoverProperty?.reservationArrivalApi"
                      [isPrintMode]="isPrintMode"></app-report-reservation>
                    }
                  </td>
                </tr>
              }
            </ng-template>
          </p-table>
        </div>
      </ng-template>
    </p-table>

    <!-- Export Loading Dialog -->
    <p-dialog [(visible)]="exportLoading" [modal]="true" [closable]="false" [draggable]="false" [resizable]="false"
      [style]="{width: '450px'}" styleClass="export-loading-dialog" [baseZIndex]="10000">
      <div class="export-loading-content">
        <div class="spinner-container">
          <p-progressSpinner [style]="{width: '60px', height: '60px'}" strokeWidth="4" animationDuration=".8s">
          </p-progressSpinner>
        </div>

        <h2 class="dialog-title">Preparing Your PDF File</h2>

        <div class="message-container">
          <p class="main-message">
            <i class="pi pi-file-pdf" style="font-size: 1.2rem; color: #d32f2f; margin-right: 8px;"></i>
            Please wait while we prepare your PDF export...
          </p>
          <p class="creative-message">
            We're gathering all your housekeeping report data and organizing it just right for you!
          </p>
        </div>

        <div class="warning-container">
          <i class="pi pi-info-circle" style="font-size: 1rem; color: #f59e0b; margin-right: 8px;"></i>
          <span class="warning-text">Please don't refresh the page</span>
        </div>
      </div>
    </p-dialog>
  </div>